import { render, staticRenderFns } from "./teamTable.vue?vue&type=template&id=baf5b4b0"
import script from "./teamTable.vue?vue&type=script&lang=js"
export * from "./teamTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports